import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

function AddSessionModal({ open, onClose, onAddSession }) {
  const [formValues, setFormValues] = useState({
    number: '',
    name: '',
    date: '',
    startTime: '',
  });

  // Cuando se abra el modal, limpiamos el formulario.
  useEffect(() => {
    if (open) {
      setFormValues({
        number: '',
        name: '',
        date: '',
        startTime: '',
      });
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    // Aquí podrías agregar validaciones si lo deseas
    // por ejemplo, asegurarte de que "number" y "name" no estén vacíos.

    const newSession = {
      // id: uuidv4(), // si quieres usar uuid
      id: uuidv4(),
      number: formValues.number,
      name: formValues.name,
      date: formValues.date,
      startTime: formValues.startTime,
      schedules: [], // se inicia vacío
    };
    onAddSession(newSession);

    // Cierra el modal
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Agregar Sesión</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Número"
              type="number"
              name="number"
              value={formValues.number}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              label="Nombre"
              name="name"
              value={formValues.name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Fecha"
              type="date"
              name="date"
              value={formValues.date}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Hora Inicio"
              type="time"
              name="startTime"
              value={formValues.startTime}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleAdd}>
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddSessionModal;
